/** カスタムエラークラス */
export class CustomError extends Error {
  code: string;
  data: string[];

  constructor(message: string, code: string, data: string[]) {
    super(message);
    this.code = code;
    this.data = data;
  }
}
